<div
  role="button"
  class="wager-card"
  [ngStyle]="cardStyle | theme"
  [style.padding-top]="topPadding"
  [style.padding-bottom]="bottomPadding"
  [style.padding-left]="leftPadding"
  [style.padding-right]="rightPadding"
  (keydown.enter)="onClick()"
  (keydown.space)="onClick()"
  (click)="onClick()"
  tabindex="0"
  [attr.aria-label]="title + ' — ' + buttonLabel"
>
  @if (splicedBg) {
    <app-spliced-background [image]="splicedBg.imageUrl" [cornerSize]="splicedBg.cornerSize" />
  }
  <div [ngStyle]="titleStyles | theme">
    {{ title }}
  </div>
  <div class="prize-container">
    <div class="prize-stack">
      @if (hasPrizeShadow()) {
        <div [ngStyle]="prizeShadowStyles | theme" class="prize-shadow">
          {{ prize }}
        </div>
      }
      <div [ngStyle]="prizeStyles | theme" class="prize-text">
        {{ prize }}
      </div>
    </div>
  </div>
  <div class="entry-container">
    <div [ngStyle]="enterStyle | theme">
      {{ buttonLabel }}
    </div>
  </div>
  <div class="play-button" [ngStyle]="playButtonStyles | theme">
    @if (splicedPlayBg) {
      <app-spliced-background
        [image]="splicedPlayBg.imageUrl"
        [cornerSize]="splicedPlayBg.cornerSize"
      />
    }
    <span [ngStyle]="playButtonLabelStyles | theme">{{ playLabel }}</span>
  </div>
</div>
